import _ from 'lodash';
import { generateErrorKey } from 'src/tools/helper';
export const productInfoCheck = (info) => {
  const _i = _.cloneDeep(info);
  let flag;
  if (!_i.name) {
    _i[generateErrorKey('name')] = true;
    flag = true;
  }
  return { data: info, flag };
};
